import React, { Component } from 'react';


class LastRefreshed extends Component {
    constructor(props) {
        super(props);
        this.state = { }
    }

    humanizeDateTime = function({ dateAsString, currentDate = new Date() }) {
        const date = new Date(Date.parse(dateAsString))
        const dateTimeDifference = currentDate - date;
        if (dateTimeDifference < 60000) {
            return 'Less than a minute ago'
        } else if (dateTimeDifference <= 120000) {
            return '1 minute ago'
        } else if (dateTimeDifference <= 3600000) {
            var timeInMinutes = Math.floor(dateTimeDifference / 60000)
            return timeInMinutes + ' minutes ago'
        } else {
            return 'Over an hour ago'
        }
    }

    componentDidMount() {
        this.intervalUpdate = setInterval(() => {
            this.forceUpdate();
        }, 2000);
    }

    componentWillUnmount() {
        if (this.intervalUpdate) {
            clearInterval(this.intervalUpdate);
            this.intervalUpdate = null;
        }
    }

    render() {
        const timeAsString = this.props.dateAsString
        const time = this.humanizeDateTime({ dateAsString: timeAsString })
        return <span>{time}</span>;
    }
} export default LastRefreshed